import { Box, TextField } from '@mui/material';
import React from 'react'
import { BACKSPACE, ENTER} from '../assets/constants/Constants';

export const CustomBoxInputOtp = ({handlePaste, inputValue, handleChange, inputRefs, error, handleSubmitEvent, disabled, customClass = null }) => {
	const handleKeyDown = (event, index) => {
    if (event.key === BACKSPACE) {
        event.preventDefault();
        const currentValue = inputValue[index];
        if (currentValue !== '') {
            handleChange({ target: { value: '' } }, index);
        } else if (index > 0) {
            // Move to previous and clear that
            inputRefs.current[index - 1]?.focus();
            handleChange({ target: { value: '' } }, index - 1);
        }
    }
    if (event.key === ENTER) {
        if (!disabled) {
            handleSubmitEvent();
            event.target.blur();
        }
    }    
};

	const getBoxInputClassName = (boxInputValue) => {
		let className = customClass ? `box-input ${customClass}` : 'box-input';
		if (boxInputValue) {
			className = `${className} filled`;
		}
		return className;
	};

     // Find first empty box index for initial auto-focus
    const firstEmptyIndex = inputValue.findIndex(val => val === '');

    return (
        <Box className="custom-box-input">
            {inputValue.map((value, index) => (
                <TextField
					onPaste={handlePaste}
                    key={index}
                    onChange={(event) => handleChange(event, index)}
                    onKeyDown={(event) => handleKeyDown(event, index)}
                    inputRef={(el) => (inputRefs.current[index] = el)}
                    className="input-container"
                    value={value}
                    error={error && !value}
                    inputProps={{
                        maxLength: 1,
                        className: getBoxInputClassName(value),
						autoComplete: 'one-time-code',
                        inputMode: 'numeric',
                        pattern: '[0-9]*',
                    }}
                    autoFocus={index === 0 || index === firstEmptyIndex}
                />
            ))}
        </Box>
    );
};
